<template>
  <avue-crud
    ref="crud"
    :data="tableData"
    :option="option"
    :table-loading="showLoading"
    :page.sync="page"
    @on-load="onLoad"
    @selection-change="selectionChange"
  >
    <template #header>
      <div>
        <div class="flex align-items marginBottom20">
          <div class="flex align-items marginRight10">
            <div class="width200">
              <el-input
                v-model="searchData.nickname"
                placeholder="请输入用户昵称或手机号"
                clearable
                maxlength="50"
              ></el-input>
            </div>
          </div>
          <el-button
            size="medium"
            type="primary"
            @click="handleSearch"
            class="marginLeft10"
            >搜索</el-button
          >
        </div>
      </div>
    </template>
    <template slot="menu" slot-scope="{ row }">
      <el-button
        type="text"
        size="mini"
        @click="handleEdit(row)"
        v-if="userId != row.id"
        >选择</el-button
      >
    </template>
  </avue-crud>
</template>

<script>
import { selectList } from "@/api/user/group";

export default {
  name: "index",
  props: {
    userId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      searchData: {
        nickname: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: false,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "ID",
            prop: "userId",
          },
          {
            label: "用户昵称",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "注册时间",
            prop: "createTime",
            width: 150,
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        nickname: this.searchData.nickname,
      };

      selectList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    //编辑
    async handleEdit(row) {
      this.$emit("selectUserId", row);
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped>
</style>